// This file should contain any javascript required to run on the category pages
import {checkListViewCookie} from "../../app/functions/checkListViewCookie";
import {getActionUrlForPriceFilter} from "../../app/functions/getActionUrlForPriceFilter";
import {submitFilterForm} from "../../app/functions/submitFilterForm";
import {getCategoryUrlFromPricesAndConversion} from "../../app/functions/getCategoryUrlFromPricesAndConversion";
import {getActionUrlForYearFilter} from "../../app/functions/getActionUrlForYearFilter";

$.pjax.defaults.timeout = 5000;
$.pjax.defaults.maxCacheLength = 0;

$(document).on('pjax:send', function() {
    $('.loading-screen').fadeIn();
});

$(document).on('pjax:complete', function() {
    $('.loading-screen').fadeOut();
    checkListViewCookie();
});

checkListViewCookie();

/*if (window.location.hash) {
    var hash = window.location.hash.substring(1),
        filters = hash.split('::');
    Array.prototype.forEach.call(filters ,function(value){
        var filter = value.split(':'),
            filter_type = filter[0],
            filter_name = filter[1],
            filter_value = filter[2],
            el = document.querySelector('#pjax-form');
        el.innerHTML += '<input type="hidden" class="selected_hidden_filter" name="filters[' + filter_type + '][' + filter_name + ']" value="' + decodeURI(filter_value) + '" data-type="product_column" data-filter="stock_status">';
    });
    submitFilterForm();
}*/

$(document).off('click', '#page-category .filter-section li a');

// Checkbox category selections
$(document).on('change', '#page-category input', function() {
    if (!($(this).attr('id') == 'date_input_min' || $(this).attr('id') == 'date_input_max' ||
        $(this).attr('id') == 'price_input_min' || $(this).attr('id') == 'price_input_max'
    )) {
        var url = $(this).data('url');

        if (!url) {
            url = $(this).parents('form').attr('action');
        }

        submitFilterForm(url);
    }

    return false;
});

// Submission of year range inputs
$(document).on('click', '#page-category #date_input_button', function() {
    var params_url,
        action_url,
        url,
        date_min = $('#date_input_min').val(),
        date_max = $('#date_input_max').val();

    [action_url, params_url] = getActionUrlForYearFilter($(this));

    if (date_min == '') {
        date_min = $('#date_input_min').data('min');
    }

    if (date_max == '') {
        date_max = $('#date_input_max').data('max');
    }

    if (typeof date_max != "undefined" && typeof date_min != "undefined" && date_min != '' && date_max != '') {
        url = action_url + '/' + date_min + '-' + date_max;
    } else {
        url = action_url;
    }

    if (params_url != '' && params_url != null) {
        url = url + params_url;
    }

    if (!($('#date_input_min').data('min') == date_min && $('#date_input_max').data('max') == date_max)) {
        $('#pjax-form').append('<input type="hidden" id="product-year_min" name="ranges[year][min]">');
        $('#pjax-form').append('<input type="hidden" id="product-year_max" name="ranges[year][max]">');
        $('#product-year_min').val(date_min);
        $('#product-year_max').val(date_max);
        submitFilterForm(url);
    }

    return false;
});

// Submission of price range inputs
$(document).on('click', '#page-category #price_input_button', function() {
    var price_min = $('#price_input_min').val(),
        price_max = $('#price_input_max').val(),
        price_conversion = $('#price_input_button').data('price_conversion'),
        action_url,
        params_url,
        url;

    [action_url, params_url] = getActionUrlForPriceFilter($(this));

    url = getCategoryUrlFromPricesAndConversion(action_url, price_min, price_max, price_conversion);

    if (params_url != null) {
        url = url + params_url;
    }

    if (!($('#price_input_min').data('min') == price_min && $('#price_input_max').data('max') == price_max)) {
        $('#pjax-form').append('<input type="hidden" id="product-price_min" name="ranges[price_numeric][min]">');
        $('#pjax-form').append('<input type="hidden" id="product-price_max" name="ranges[price_numeric][max]">');
        $('#product-price_min').val(price_min);
        $('#product-price_max').val(price_max);
        submitFilterForm(url);
    }

    return false;
});

$(document).on('submit', '#pjax-form', function(event) {
    $.pjax.submit(event, '#category-pjax-container');
});

// Sort by filter - update hidden input with selected value
$(document).on('change keyup', '#page-category #sort-by-filter', function() {
    var val = $(this).val(),
        action = $(this).data('url'),
        url;

    if (action.indexOf('?sort_by') >= 0 || action.indexOf('&sort_by') >= 0) {
        url = action.substring(0, action.indexOf('sort_by')) + 'sort_by=' + val;
    } else if (action.indexOf('?') >= 0) {
        url = action + '&sort_by=' + val;
    } else {
        url = action + '?sort_by=' + val;
    }

    $('#product-sort_by').val(val).change();
    submitFilterForm(url);
    return false;
});

// Collapsible Filters
$(document).on('click', '#page-category .filter-section:not(.filter-section-selection) h3', function() {
    var filter = $(this).parent();

    if (filter.hasClass('filter-section-collapsed')) {
        filter.find('ul, span').slideDown(function() {
            filter.removeClass('filter-section-collapsed');
        });
    } else {
        filter.find('ul, span').slideUp(function() {
            filter.addClass('filter-section-collapsed');
        });
    }
    return false;
});

// Weight filter checkbox validation - allow only one selection
$(document).on('change', '#page-category #weight input', function() {
    $('#weight input').not(this).prop('checked', false);
});

$(document).on('click', '#page-category .show-more', function() {
    $(this).next().slideToggle();
    $(this).parent('.children').toggleClass('expanded');
});

$(document).on('click', '#page-category .filter-section-selection-choice:not(.filter-section-selection-choice-base)', function() {
    var type =  $(this).data('type'),
        filter =  $(this).data('filter'),
        value =  $(this).data('value'),
        str_value = value,
        url =  $(this).data('url'),
        name = 'filters[' + type + '][' + filter + ']',
        selector = ".filter-wrapper input[value='"+ value +"'][name='" + name + "']";

    if (typeof value == 'string') {
        str_value = value.replace(/\s+/g, '');
    }

    var hidden_selector = "input.selected_hidden_filter[value='"+ str_value +"'][name='" + name + "']";

    $(selector).remove();
    $(hidden_selector).remove();

    $(this).remove();
    if (typeof url === 'undefined') {
        submitFilterForm();
    } else {
        submitFilterForm(url);
    }
});

$(document).on('click', '#page-category .filter-section-selection small', function() {
    var url =  $(this).data('url'),
        selector = ".selected_hidden_filter";
    $(selector).remove();
    $(this).hide();
    $('.filter-section-selection-choice:not(.filter-section-selection-choice-base)').hide();
    if (typeof url === 'undefined') {
        submitFilterForm();
    } else {
        submitFilterForm(url);
    }
});

$(document).on('click', '#page-category .filter-see-more', function() {
    var filter = $(this).parents('.filter-section');

    if ($(this).hasClass('filter-see-less')) {
        filter.find('.filter-hidden').hide();
        $(this).removeClass('filter-see-less');
        $(this).html('+ See More');
    } else {
        filter.find('.filter-hidden').show();
        $(this).addClass('filter-see-less');
        $(this).html('- See Less');
    }
    return false;
});

$(document).on('click', '#page-category .pagination a', function() {
    var url = $(this).attr('href');

    submitFilterForm(url);
    return false;
});
